import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { user, isAuthenticated, logout } = useAuth();

  const ADMIN_EMAILS = ["julie@jcp-teaching.com", "test@example.com", "jc-p@outlook.de"];
  const isAdmin = user && ADMIN_EMAILS.includes(user.email);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <a href="/" className="navbar-logo" data-testid="navbar-logo">
          <span className="jcp-logo">JCP</span><span className="navbar-logo-text"> Teaching</span>
        </a>
        <div className="navbar-links">
          <div className="language-switcher">
            {/* Desktop/iPad buttons */}
            <button
              className={`language-btn ${i18n.language === 'de' ? 'active' : ''}`}
              onClick={() => changeLanguage('de')}
              data-testid="lang-de"
            >
              DE
            </button>
            <button
              className={`language-btn ${i18n.language === 'da' ? 'active' : ''}`}
              onClick={() => changeLanguage('da')}
              data-testid="lang-da"
            >
              DA
            </button>
            <button
              className={`language-btn ${i18n.language === 'en' ? 'active' : ''}`}
              onClick={() => changeLanguage('en')}
              data-testid="lang-en"
            >
              EN
            </button>
            
            {/* iPhone dropdown */}
            <div className="language-dropdown">
              <select 
                value={i18n.language} 
                onChange={(e) => changeLanguage(e.target.value)}
                data-testid="lang-dropdown"
              >
                <option value="de">DE</option>
                <option value="da">DA</option>
                <option value="en">EN</option>
              </select>
            </div>
          </div>

          {/* Auth buttons */}
          <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginLeft: '1rem' }}>
            {isAuthenticated ? (
              <>
                <button
                  onClick={() => navigate(isAdmin ? '/admin' : '/dashboard')}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#7c6f5e',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: 500
                  }}
                >
                  {isAdmin ? 'Admin' : user?.name}
                </button>
                <button
                  onClick={handleLogout}
                  style={{
                    background: 'none',
                    border: '1px solid #7c6f5e',
                    color: '#7c6f5e',
                    cursor: 'pointer',
                    padding: '0.4rem 1rem',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontWeight: 500
                  }}
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={() => navigate('/login')}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#7c6f5e',
                    cursor: 'pointer',
                    fontSize: '0.95rem',
                    fontWeight: 500
                  }}
                >
                  Login
                </button>
                <button
                  onClick={() => navigate('/signup')}
                  style={{
                    background: '#7c6f5e',
                    border: 'none',
                    color: 'white',
                    cursor: 'pointer',
                    padding: '0.4rem 1rem',
                    borderRadius: '5px',
                    fontSize: '0.9rem',
                    fontWeight: 500
                  }}
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;